import AzurePlanUsageCSP from "../../models/csp/AzurePlanUsageCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  methods: {
    getAzurePlanUsagesCSP: async function (
      customerId: string,
      azurePlanId: string
    ): Promise<AzurePlanUsageCSP[]> {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${customerId}/subscriptions/${azurePlanId}/resourceusagerecords`
      );
      return res.items.map(
        azPlanUsage =>
          new AzurePlanUsageCSP({
            azurePlanId: azPlanUsage.subscriptionId, // Refers to Azure Plan Id, but is considered as any other Microsoft "Subscription" Id
            entitlementId: azPlanUsage.entitlementId,
            entitlementName: azPlanUsage.entitlementName,
            resourceGroupName: azPlanUsage.resourceGroupName,
            totalCost: azPlanUsage.totalCost
          })
      );
    }
  }
};
